var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.05 31.05 40 20 40C8.95 40 0 31.05 0 20C0 8.95 8.95 0 20 0C31.05 0 40 8.95 40 20Z",
    fill: "url(#paint0_linear_443_81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3334 29.1666C15.6834 29.1666 15.8 28.9166 15.5667 28.3L13.6667 22.0333L25.4667 14.6666L26.85 15.0333L25.7 18.1666L16.3334 29.1666Z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 29.1667C16.8333 29.1667 17.05 28.9333 17.3333 28.6667C17.7666 28.25 23.3333 22.8333 23.3333 22.8333L19.9166 22L16.75 24L16.3333 29V29.1667Z",
    fill: "#A9C9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 24.0667L24.7334 30.0167C25.65 30.5167 26.3167 30.2667 26.55 29.1667L29.8334 13.7C30.1667 12.35 29.3167 11.75 28.4334 12.15L9.16669 19.5834C7.85002 20.1167 7.86669 20.85 8.93335 21.1667L13.8834 22.7167L25.3334 15.5C25.8667 15.1667 26.3667 15.35 25.9667 15.7167L16.6667 24.0667Z",
    fill: "url(#paint1_linear_443_81)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_443_81",
    x1: 25.8617,
    y1: 6.32167,
    x2: 15.8617,
    y2: 29.6547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_443_81",
    x1: 21.4985,
    y1: 20.6259,
    x2: 25.6652,
    y2: 27.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.57d29f9869e29eba90a01c2f63ba8856.svg";
export { ForwardRef as ReactComponent };